import { render, staticRenderFns } from "./ApplicationSummary.vue?vue&type=template&id=32c43db5&scoped=true&"
import script from "./ApplicationSummary.vue?vue&type=script&lang=js&"
export * from "./ApplicationSummary.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSummary.vue?vue&type=style&index=0&id=32c43db5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c43db5",
  null
  
)

export default component.exports